var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading',{attrs:{"loading":_vm.isLoading,"message":_vm.loadingMessage}},[_c('error',{attrs:{"error":_vm.error}}),(_vm.data)?_vm._t("default",null,{"page":_vm.data}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }